
































// require('./lib/ui/root.js');

import inlineTextEdit from "../../components/inlineTextEdit.vue"
import ripple from "../../components/ripple.vue"
import tooltip from "../../components/tooltip.vue"
import gbutton from "../../components/button.vue"
import graph from "../../components/lineGraph.js"

import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import moment,{ weekdays, Moment } from "moment";
import { setInterval } from "timers";
import {frontendClient} from "../../lib/client";

@Component({
    components : {
        ripple,
        inlineTextEdit,
        gbutton,
        graph,
        tooltip,
    },
})
export default class User extends Vue{
    perc:number = 0;
    updatingUser:boolean = false;

    date:string = moment(new Date()).format("ddd Do MMM YYYY");
    user = frontendClient.userData;

    mounted(){
       this.$emit('scope','home');
    }

    updateUser(){
        this.$emit('editPrompt',{instance:'password',object:null});
    }

    redirect(route,parameters?){
        if(parameters){
            this.$router.replace({ name: route, params: parameters});
        }else{
            this.$router.push({ name: route, params: parameters});
        }
    };

}
